import { transformNumbersToRange } from '@/util/numberHelpers'
import Meter from '.'

interface Props {
  className?: string
  percentage: number
}

export const ScarcityMeter = ({ percentage, className }: Props) => {
  const transformedValue = Math.ceil(
    transformNumbersToRange(percentage, 0, 100, 0, 16)
  )
  let meterColor = 'text-rarity-uncommon'

  if (transformedValue < 5) {
    meterColor = 'text-error'
  } else if (transformedValue < 9) {
    meterColor = 'text-alert'
  } else if (transformedValue < 13) {
    meterColor = 'text-rarity-ultra'
  }

  return (
    <Meter
      className={className}
      value={transformedValue}
      min={0}
      max={16}
      activeColorClass={meterColor}
    />
  )
}
